<template>
    <div class="trz_leave_settings">       

        <div class="col-sm-12">
            <div class="ibox p-3">

                <div class="employee-table-wrapper">
                    <div class="row my-3">
                        <div class="col-sm-4">
                            <b-input-group>
                                <b-input-group-prepend is-text>Year</b-input-group-prepend>
                                <b-form-select plain id="year" name="year" v-model="year"
                                    :options="$year_options" @change="getHoliDays"></b-form-select>
                            </b-input-group>
                        </div>
                    </div>

                    <table class="employee-list-table table-overflow ess-custom-table document-table tax-documents table-list fund_list_table dataTable border">
                        <thead class="table-head">
                            <tr>
                                <td class="checkbox-col">
                                    <input type="checkbox" v-model="selectAll">
                                    <label for=""></label>
                                </td>
                                <th>Date</th>
                                <th>Title</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(holiday, index) in holidays" :key="holiday.id">
                                <td class="checkbox-col">
                                    <input type="checkbox" v-model="selected" :value="holiday.id">
                                    <label for=""></label>
                                </td>
                                <td>{{ formatdate(holiday.holiday_date) }}</td>
                                <td :title="holiday.comment" v-b-tooltip placement="right">
                                    {{ holiday.comment }}
                                </td>
                            </tr>
                            <tr v-if="!holidays || holidays.length === 0">
                                <td colspan="4" class="text-center text-muted">No holidays found.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="full-width text-center">
                <b-button type="submit" variant="primary" class="px-3" @click="saveHoliDays">Sync</b-button>
            </div>
        </div>
    </div>
</template>
<script>

    import moment from 'moment'

    export default{
        
        mounted() {
            //alert(moment(new Date()).format('YYYY-MM-DD'));
        }, 
        components: {

        },
        data() {

            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th two months prior
            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth())
            minDate.setDate(minDate.getDate() + 1)
            /*const maxDate = new Date(today)
            maxDate.setMonth(maxDate.getMonth() + 2)
            maxDate.setDate(15)*/
            const startdate = minDate

            return {
                min: minDate,
                //max: maxDate,
                holiday_one: startdate, holiday_two: startdate,
                fdata: { id: 0, holiday_one: startdate, holiday_two: startdate, days: null, comment: null },
                holiday: {},

                start_date: startdate,

                holidays: [],
                selected: [],

                year: now.getFullYear(),
                year_options: [
                    { text: '2019', value: '2019' },
                    { text: '2020', value: '2020' },
                    { text: '2021', value: '2021' },
                    { text: '2022', value: '2022' },
                    { text: '2023', value: '2023' },
                    { text: '2024', value: '2024' },
                    { text: '2025', value: '2025' },
                    { text: '2026', value: '2026' },
                ],


            }
        },
        methods: {
            formatdate: function (x) {
                return moment(x).format('Do MMMM YYYY');
            },
            checkGaterDate(x) {
                return moment(x).isAfter(moment(new Date()).format('YYYY-MM-DD'));
            },
            getHoliDays: function () {
                if (!this.checkNet()) return false;
                axios.get(this.$api_url + '/leave-attendance/government/holidays/list?year=' + this.year, {
                    params: {
                        //id: x
                    }
                }).then(function (response) {

                    if (response.data.length != 0) {
                        this.holidays = response.data.holidays;
                    }

                }.bind(this));

            },
            saveHoliDays: function () {
                if (this.selected.length == 0) {
                    alert('Nothing selected');
                    return false;
                }

                let currentObj = this;
                let formData = new FormData();
                formData.append('selected', this.selected);

                axios.post(this.$api_url + '/leave-attendance/government/holidays/sync', formData,)
                    .then(function (response) {
                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.$emit('childToParent');
                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                    });

            },
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
        },
        created: function () {

            this.getHoliDays();
        },
        computed:
        {
            dateDiff() {
                //fdata : {holiday_one:null , holiday_two:null, days:null , details:null},

                var holiday_one = moment(this.holiday_one);
                var holiday_two = moment(this.holiday_two);

                this.fdata.holiday_one = moment(String(this.holiday_one)).format('YYYY-MM-DD');
                this.fdata.holiday_two = moment(String(this.holiday_two)).format('YYYY-MM-DD');

                if (this.holiday_one == this.holiday_two) {
                    this.fdata.days = 1;
                    return 1;
                }
                let days = holiday_two.diff(holiday_one, 'days') // 1

                if (days > 0) {
                    ++days;
                    this.fdata.days = days;
                    return days;
                }
                else if (days < 0) {
                    this.fdata.days = 0;
                    return 'Invalid Date Range';
                }

            },
            fetchStartWeekday() {
                return this.week_start_day;
            },
            selectAll: {
                get: function () {
                    return this.holidays ? this.selected.length == this.holidays.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.holidays.forEach(function (user) {
                            selected.push(user.id);
                        });
                    }

                    this.selected = selected;
                }
            }

        }
    }
</script>
